import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Safe from "@/pages/Safe";
import Trusted from "@/pages/Trusted";
import Lifesign from "@/pages/Lifesign";
import Referral from "@/pages/Referral";
import Activate from "@/pages/Activate";
import Legal from "@/pages/Legal";
import AdminLegal from "@/pages/AdminLegal";

function Protected({ children }) {
    const { authState } = useApp();
    if (authState === "checking") {
        return <div className="min-h-screen flex items-center justify-center text-shield-muted">Lädt…</div>;
    }
    if (authState === "out") return <Navigate to="/login" replace />;
    return children;
}

function RouterInner() {
    const location = useLocation();
    // Handle OAuth session fragment synchronously
    if (location.hash?.includes("session_id=")) return <AuthCallback />;

    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/safe" element={<Protected><Safe /></Protected>} />
            <Route path="/trusted" element={<Protected><Trusted /></Protected>} />
            <Route path="/lifesign" element={<Protected><Lifesign /></Protected>} />
            <Route path="/referral" element={<Protected><Referral /></Protected>} />
            <Route path="/activate" element={<Protected><Activate /></Protected>} />
            <Route path="/activate/mock-checkout" element={<Protected><Activate /></Protected>} />
            <Route path="/activate/success" element={<Activate />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/admin/legal" element={<Protected><AdminLegal /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <AppProvider>
                <BrowserRouter>
                    <RouterInner />
                </BrowserRouter>
            </AppProvider>
        </div>
    );
}

export default App;
